var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00049 2.47059V2.47059C1.00049 1.6584 1.65889 1 2.47108 1L10.0248 1C10.2568 1 10.4449 1.18812 10.4449 1.42017V1.42017C10.4449 2.81248 9.31624 3.94118 7.92392 3.94118H7.66715M1.00049 2.47059V2.47059C1.00049 3.28277 1.65889 3.94118 2.47108 3.94118L9.00049 3.94118C9.9433 3.94118 10.4147 3.94118 10.7076 4.23407C11.0005 4.52696 11.0005 4.99837 11.0005 5.94118L11.0005 6.29412M1.00049 2.47059L1.00049 7C1.00049 8.88562 1.00049 9.82843 1.58627 10.4142C2.17206 11 3.11487 11 5.00049 11L9.00049 11C9.9433 11 10.4147 11 10.7076 10.7071C11.0005 10.4142 11.0005 9.94281 11.0005 9L11.0005 8.64706M11.0005 8.64706H8.84362C8.6797 8.64706 8.59774 8.64706 8.529 8.63747C8.08639 8.57573 7.73848 8.22782 7.67674 7.78521C7.66715 7.71647 7.66715 7.63451 7.66715 7.47059V7.47059C7.66715 7.30667 7.66715 7.22471 7.67674 7.15596C7.73848 6.71336 8.08639 6.36545 8.529 6.30371C8.59774 6.29412 8.6797 6.29412 8.84362 6.29412H11.0005M11.0005 8.64706L11.0005 6.29412",
    stroke: "#CCD2E3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.c6525a01d224b03f9d4ba457aac81f03.svg";